import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { LoadingProvider } from './context/LoadingContext';
import ThemeTransition from './components/ThemeTransition';
import Loading from './components/Loading';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import TrustedBy from './sections/TrustedBy';
import Solutions from './sections/Solutions';
import Industries from './sections/Industries';
import Process from './sections/Process';
import CaseStudies from './sections/CaseStudies';
import CRMPanels from './sections/CRMPanels';
import WhyAFSC from './sections/WhyAFSC';
import About from './sections/About';
import Video from './sections/Video';
import Contact from './sections/Contact';
import Footer from './sections/Footer';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <LoadingProvider>
          <Loading />
          <ThemeTransition>
            <div className="App">
              <Navbar />
              <Hero />
              <About />
              <Video />
              <WhyAFSC />
              <Solutions />
              <Industries />
              <Process />
              <CaseStudies />
              <CRMPanels />
              <TrustedBy />
              <Contact />
              <Footer />
            </div>
          </ThemeTransition>
        </LoadingProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
